import styles from './card.scss';

const Card = (props) => {
    const showHeader = props.header ?
        <div>
            <div className={styles.sceCardHeader}> {props.header} </div>
            <div className={[styles.sceYellowLine, 'sce-space-md'].join(" ")} />
        </div>
        : null;
    return (
        <div className={styles.sceCardOutline}>
            {showHeader}
            <div> {props.children} </div>
        </div>
    );
};

export default Card;

